import { render, staticRenderFns } from "./JourneyDuration.vue?vue&type=template&id=1b2b60a6&"
import script from "./JourneyDuration.vue?vue&type=script&lang=js&"
export * from "./JourneyDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports